import { DashboardView } from "@/features/dashboard/components/DashboardView"

export default function DashboardPage() {
  return <DashboardView />
}